import { render, staticRenderFns } from "./ProgramChoice.vue?vue&type=template&id=0dfc15be"
import script from "./ProgramChoice.vue?vue&type=script&lang=js"
export * from "./ProgramChoice.vue?vue&type=script&lang=js"
import style0 from "./ProgramChoice.vue?vue&type=style&index=0&id=0dfc15be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports